import React from 'react';
import { SubscriptionsBoardPage } from './board';

export const SubscriptionsModule = () => {
  return <SubscriptionsBoardPage />;
};
